import { render, staticRenderFns } from "./SalaryIncurredConfig.vue?vue&type=template&id=feb64cae&scoped=true"
import script from "./SalaryIncurredConfig.vue?vue&type=script&lang=js"
export * from "./SalaryIncurredConfig.vue?vue&type=script&lang=js"
import style0 from "./SalaryIncurredConfig.vue?vue&type=style&index=0&id=feb64cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb64cae",
  null
  
)

export default component.exports